import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  smtp_details: {},
  is_autoresponder_loaded: false,
  autoresponder: {},
};

const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSMTPDetails(state, action) {
      state.smtp_details = action.payload.smtp_details;
    },
    setAutoresponder(state, action) {
      state.autoresponder = action.payload.autoresponder;
      state.is_autoresponder_loaded = true;
    },
    setAutoresponderStatus(state, action) {
      state.is_autoresponder_loaded = action.payload.status;
    },
  },
});

export const settingAction = settingSlice.actions;
export default settingSlice.reducer;
